/* eslint-disable react/prop-types */
import "./ShowUserInfo.css";
import React, { useEffect, useState, useMemo, useContext, useCallback } from "react";
import { Store } from "../Store/store";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Chip from "@mui/material/Chip";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { API_URL, custom_axios_post, kbnOptions } from "./Common";
import { useHistory } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import Slide from "@mui/material/Slide";
import styled from "@emotion/styled";
import ShowTimelineButtonSelect from "./ShowTimelineButtonSelect";
import ShowTimelinePost from "../Common/ShowTimelinePost";
import Link from "@mui/material/Link";
import ShowTimelineRead from "../Common/ShowTimelineRead";
import CircularProgress from "@mui/material/CircularProgress";
import {
  DataGridPro as DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  // GridToolbarDensitySelector,
  // GridToolbarExport,
  gridPageCountSelector,
  GridPagination,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import MuiPagination from "@mui/material/Pagination";
import ShowCommon from "../Common/ShowCommon";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});
const StyledCircularProgress = styled(CircularProgress)`
  color: ${(props) => props.theme.palette.primary.light};
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12;
  margin-left: -12;
`;
function CustomToolbar() {
  //プロパティから utf8WithBom = Turue を渡してあげる。
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      {/* <GridToolbarDensitySelector /> */}
      {/* <GridToolbarExport csvOptions={{ utf8WithBom: true }} /> */}
    </GridToolbarContainer>
  );
}
function Pagination({ page, onPageChange, className }) {
  const apiRef = useGridApiContext();

  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <MuiPagination
      color="primary"
      className={className}
      count={pageCount}
      page={page + 1}
      onChange={(event, newPage) => {
        onPageChange(event, newPage - 1);
      }}
    />
  );
}

function CustomPagination(props) {
  return <GridPagination ActionsComponent={Pagination} {...props} />;
}
const headCells = [
  { id: "timelineid", label: "ID" },
  { id: "title", label: "タイトル" },
  { id: "kbnname", label: "表示区分" },
  { id: "name", label: "表示名" },
  { id: "editname", label: "ポスト作成者" },
  { id: "time", label: "更新日付" },
  { id: "istarget", label: "対象者" },
  { id: "isread", label: "既読数" },
  { id: "issend", label: "公開状況" },
  { id: "option", label: "オプション" },
];

const StyledDataGrid = styled("div")`
  height: 100%;
  weight: 100%;
`;

const StyledRapDataGrid = styled("div")`
  height: calc(100vh - 130px);
`;

const StyledDialogTitle = styled(DialogTitle)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 5px 10px;
`;

const StyledButton = styled(Button)`
  color: ${(props) => props.theme.palette.primary.contrastText};
  background-color: ${(props) => props.theme.palette.primary.main};
  padding: 5px 10px;
`;

const StyledDialogContent = styled(DialogContent)`
  padding: 0px;
`;

const StyledRoot = styled("div")`
  width: 100%;
`;

function ShowTimelineList({ open, handleClose }) {
  const history = useHistory();
  const { state, hubConnection } = useContext(Store);
  const [loading, setLoading] = useState(false);

  const [timelineList, setTimelineList] = useState([]); //APIから取得したデータを格納
  const [timelineListColumns, setTimelineListColumns] = useState([]);
  const [selectedtimeline, setSelectedTimeline] = useState({
    open: false,
    timelineid: "",
    honbuid: 0,
    createhpcode: 0,
    name: "",
    editname: "",
    kbn: 0,
    kbnname: "",
    title: "",
    message: "",
    time: "",
    iswebview: 0,
    iscomment: 0,
    istarget: 0,
    isread: 0,
    isfile: 0,
    sendflag: "",
    ids: "",
    isedit: 0,
  });

  const [hpoptions, setHPOptions] = useState([]);
  const [selectedhp, setSelectedHp] = useState([]);

  const [selectedKbn, setSelectedKbn] = useState(kbnOptions);
  const [openDelModal, setOpenDelModal] = useState({
    open: false,
    timelineid: "",
  });
  const MemoDel = useMemo(() => {
    return (
      <ShowCommon
        open={openDelModal.open}
        title="削除しますか？"
        handleClose={() => {
          setOpenDelModal((prev) => ({ ...prev, open: false }));
        }}
        handleCallBack={() => handleDell(openDelModal.timelineid)}
      ></ShowCommon>
    );
  }, [openDelModal.open]);

  const [openRead, setOpenRead] = useState({ open: false, kbn: "timeline" }); //既読ページ
  const [readtimelineid, setReadTimelineid] = useState("");
  const [readkbnname, setReadKbnname] = useState("");

  const handleReadClick = (event, readtimelineid, readkbnname) => {
    event.preventDefault();
    setReadTimelineid(readtimelineid);
    setReadKbnname(readkbnname);
    setOpenRead({ open: true, kbn: "timeline" });
  };

  const handleReadClose = useCallback(() => {
    setOpenRead({ ...openRead, open: false });
  }, [openRead]);

  const MemoReadMember = useMemo(() => {
    return (
      <ShowTimelineRead
        open={openRead}
        handleClose={handleReadClose}
        timelineid={readtimelineid}
        kbnname={readkbnname}
      />
    );
  }, [openRead]);

  const initproc = async () => {
    setLoading(true);

    /* DataGrid定義 */
    setTimelineListColumns(
      headCells.map((v) => {
        if (v.id === "option") {
          return {
            field: v.id,
            headerName: v.label,
            flex: 0.5,
            renderCell: (params) => {
              return (
                <>
                  {params.row.isedit === "1" && (
                    <ShowTimelineButtonSelect
                      handleRun={() => handleRun(params.row)}
                      handleDell={() =>
                        setOpenDelModal((prev) => ({
                          ...prev,
                          open: true,
                          timelineid: params.row.timelineid,
                        }))
                      }
                    ></ShowTimelineButtonSelect>
                  )}
                </>
              );
            },
          };
        }

        if (v.id == "name" || v.id == "editname" || v.id == "time") {
          return {
            field: v.id,
            headerName: v.label,
            flex: 0.5,
          };
        }

        if (v.id === "timelineid" || v.id == "isread") {
          return {
            field: v.id,
            headerName: v.label,
            flex: 0.2,
            type: "number",
            filterable: false,
          };
        }

        if (v.id == "istarget") {
          return {
            field: v.id,
            headerName: v.label,
            flex: 0.2,
            type: "number",
            renderCell: (params) => {
              if (params.row.kbn === "1") {
                return "-";
              } else {
                return (
                  <Link href="#" onClick={(e) => handleReadClick(e, params.row.timelineid, params.row.kbnname)}>
                    {params.row.istarget}
                  </Link>
                );
              }
            },
          };
        }

        if (v.id == "kbnname") {
          return {
            field: v.id,
            headerName: v.label,
            flex: 0.3,
            renderCell: (params) => {
              return (
                <Chip
                  label={params.row.kbnname}
                  size="small"
                  color={params.row.kbn === "1" ? "inherit" : "primary"}
                  variant="outlined"
                />
              );
            },
          };
        }

        if (v.id === "issend") {
          return {
            field: v.id,
            headerName: v.label,
            flex: 0.3,
            renderCell: (params) => {
              const isSend = params.row.sendflag === "1";
              const isStopped = params.row.sendflag === "2";
              let text = "一時保存";
              let color = "red";

              if (isSend) {
                text = "公開中";
                color = "inherit";
              } else if (isStopped) {
                text = "公開停止";
                color = "blue";
              }
              return (
                <Chip
                  label={text}
                  size="small"
                  color={color === "red" ? "error" : color === "blue" ? "info" : "inherit"}
                  variant="outlined"
                />
              );
            },
          };
        }

        return { field: v.id, headerName: v.label, flex: 1 };
      })
    );

    fetchdata([{ label: state.hpcode + ":" + state.hpname, value: state.hpcode }], selectedKbn);
  };

  const fetchdata = async (hp, kbn) => {
    let hpcodes = hp
      .map((e) => {
        return e.value;
      })
      .join("_");

    let kbns = kbn.length > 0 ? kbn.map((e) => e.value).join("_") : "";

    const body = {
      honbuid: localStorage.getItem("honbuid"),
      hpcodes: hpcodes,
      kbns: kbns,
    };

    const result = await custom_axios_post(API_URL + "/GetTimelineManagementList", body);

    const status = result.status;
    if (status === 401) {
      history.replace("/loginError");
    }
    if (status === 200) {
      setLoading(false);
      setTimelineList(result != null ? result.data.timelines || [] : []);
      setHPOptions(
        result.data.hps && Array.isArray(result.data.hps)
          ? result.data.hps.map((e) => {
              return { label: e.hpname, value: e.hpcode };
            })
          : []
      );
    }
  };

  useEffect(() => {
    if (open) {
      setSelectedHp([{ label: state.hpcode + ":" + state.hpname, value: state.hpcode }]);
      initproc();
    }
  }, [open, state.newtimelineid]); //最初に読み込む

  //掲示板編集
  const handleRun = async (row) => {
    setSelectedTimeline({
      open: true,
      timelineid: row.timelineid,
      honbuid: row.honbuid,
      createhpcode: row.createhpcode,
      name: row.name,
      editname: row.editname,
      kbn: row.kbn,
      kbnname: row.kbnname,
      title: row.title,
      message: row.message,
      time: row.time,
      iswebview: row.iswebview,
      iscomment: row.iscomment,
      istarget: row.istarget,
      isread: row.isread,
      fileno: row.fileno,
      sendflag: row.sendflag,
      ids: row.ids,
      isedit: row.isedit,
    });
  };

  //掲示板削除
  const handleDell = async (timelineid) => {
    await hubConnection.invoke("DeleteTimeline", timelineid, state.honbuid);
    setOpenDelModal((prev) => ({ ...prev, open: false }));
    fetchdata(selectedhp, selectedKbn);
  };

  const handleTimelineClose = () => {
    setSelectedTimeline((prev) => ({ ...prev, open: false }));
  };
  const MemoAlumniChat = useMemo(() => {
    return (
      <ShowTimelinePost
        open={selectedtimeline.open}
        issend={"0"}
        fileno={selectedtimeline.fileno}
        timelineid={selectedtimeline.timelineid}
        name={selectedtimeline.name}
        kbn={selectedtimeline.kbn}
        title={selectedtimeline.title}
        message={selectedtimeline.message}
        sendflagcheck={selectedtimeline.sendflag}
        iswebcheck={selectedtimeline.iswebview}
        iscommentcheck={selectedtimeline.iscomment}
        edithonbuid={selectedtimeline.honbuid}
        ids={selectedtimeline.ids}
        handleClose={handleTimelineClose}
      />
    );
  }, [selectedtimeline]);

  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({
    items: [],
  });

  const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({});

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth={"xl"}
      TransitionComponent={Transition}
    >
      <StyledDialogTitle id="max-width-dialog-title">
        {MemoAlumniChat}
        {MemoDel}
        <div className="show-member-search">
          <div className="show-member-search">ポスト一覧</div>
          <div className="question-title-actions">
            <StyledButton
              onClick={async () => {
                setSelectedTimeline({
                  open: true,
                });
              }}
              variant="outlined"
            >
              新規投稿
            </StyledButton>
            <div style={{ width: "20px" }}></div>
            <StyledButton onClick={() => handleClose()} variant="outlined">
              閉じる (Esc)
            </StyledButton>
          </div>
        </div>
      </StyledDialogTitle>
      <StyledDialogContent>
        <StyledRoot>
          <div className="user-select-area">
            <div className="user-select-subarea">
              {/* 施設 */}
              <div className="multi-select">
                <MultiSelect
                  options={hpoptions}
                  value={selectedhp}
                  onChange={(e) => {
                    setSelectedHp(e);
                    fetchdata(e, selectedKbn);
                  }}
                  labelledBy={"Select"}
                  overrideStrings={{
                    selectSomeItems: "表示施設選択...",
                    allItemsAreSelected: "全選択",
                    selectAll: "全選択",
                    search: "検索",
                    clearSearch: "検索クリア",
                  }}
                  filterOptions={(options, filter) => {
                    if (!filter) {
                      return options;
                    }
                    const re = new RegExp(filter, "i");
                    return options.filter(({ label }) => label && label.match(re));
                  }}
                />
              </div>

              {/* 区分 */}
              <div className="multi-select">
                <MultiSelect
                  options={kbnOptions}
                  value={selectedKbn}
                  onChange={(e) => {
                    setSelectedKbn(e);
                    fetchdata(selectedhp, e);
                  }}
                  labelledBy={"Select"}
                  overrideStrings={{
                    selectSomeItems: "表示区分選択...",
                    allItemsAreSelected: "全選択",
                    selectAll: "全選択",
                    search: "検索",
                    clearSearch: "検索クリア",
                  }}
                  filterOptions={(options, filter) => {
                    if (!filter) {
                      return options;
                    }
                    const re = new RegExp(filter, "i");
                    return options.filter(({ label }) => label && label.match(re));
                  }}
                />
              </div>
            </div>
          </div>

          {loading ? (
            <StyledRapDataGrid>
              <StyledCircularProgress />
            </StyledRapDataGrid>
          ) : (
            <StyledRapDataGrid>
              <StyledDataGrid>
                <DataGrid
                  columnVisibilityModel={columnVisibilityModel}
                  onColumnVisibilityModelChange={(newModel) => setColumnVisibilityModel(newModel)}
                  filterModel={filterModel}
                  onFilterModelChange={(newFilterModel) => setFilterModel(newFilterModel)}
                  sortModel={sortModel}
                  onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                  getRowId={(row) => row.timelineid}
                  hideFooterSelectedRowCount={true}
                  rows={timelineList}
                  columns={timelineListColumns}
                  pagination
                  density={"compact"}
                  // checkboxSelection
                  disableRowSelectionOnClick
                  slots={{
                    toolbar: CustomToolbar,
                    pagination: CustomPagination,
                  }}
                  // initialState={{
                  //   columns: {
                  //     columnVisibilityModel: {
                  //       honbuid: false,
                  //     },
                  //   },
                  // }}
                  // localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                ></DataGrid>
              </StyledDataGrid>
            </StyledRapDataGrid>
          )}
        </StyledRoot>
      </StyledDialogContent>
      {MemoReadMember}
    </Dialog>
  );
}

export default ShowTimelineList;
